<div kendoTooltip class="right-user">
    <span [title]="title" (click)="viewDetail.emit(data)">
        {{data.userName}}
    </span>
</div>